import React from 'react';
import { noop, isFunction } from 'lodash';
import classnames from 'classnames';
import { useBreakpoints } from '@fiverr-private/business_blocks';
import { I18n } from '@fiverr-private/i18n-react';
import { Icon } from '@fiverr-private/fit';
import { l_times } from '@fiverr-private/icons';
import { Modal as OrcaModal } from '@fiverr-private/orca';

import classes from './index.module.scss';

/**
 * Pass render props into functional React.ReactNode if needed
 * @param {React.ReactNode|React.ReactNode[]} children
 * @param {{close(): void;}} props
 * @returns {import('./index').Children[]}
 */
const getChildrenWithProps = (children, props) =>
    Array.isArray(children)
        ? children.map((child) => (isFunction(child) ? child(props) : child))
        : [isFunction(children) ? children(props) : children];

/** @type {import('./index').Modal} */
const Modal = ({ className, overlayClassName, onClose = noop, children, ...props }) => {
    const { isSM } = useBreakpoints();

    return (
        <OrcaModal
            overlayClassName={classnames(classes.overlay, overlayClassName)}
            className={classnames(className, { [classes.modalMobile]: !isSM })}
            onClose={onClose}
            {...props}
        >
            {({ close }) => (
                <>
                    <div
                        onClick={close}
                        role="button"
                        className={classnames(classes.closeButton, 'tbody-5 text-semi-bold flex flex-items-center')}
                    >
                        <Icon className={classes.closeIcon} size={16}>
                            {l_times}
                        </Icon>
                        <div className="m-l-8">
                            <I18n k="freelancer_page.modal.close" />
                        </div>
                    </div>
                    <div className={classes.modal}>{getChildrenWithProps(children, { close })}</div>
                </>
            )}
        </OrcaModal>
    );
};

export default Modal;
